import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useTeamMessages } from "./TeamMessagesProvider";

// Blocking dialog for team messages flagged "show immediately" (Visa direkt) in
// ECO. Shows one unacknowledged message at a time; acknowledging advances to the
// next (if any) and marks the message read so it is not shown again.
export default function ImmediateTeamMessageDialog() {
  const { t } = useTranslation();
  const { immediateMessages, acknowledgeImmediate } = useTeamMessages();

  const message = immediateMessages[0] ?? null;

  if (!message) {
    return null;
  }

  return (
    <Dialog open disableEscapeKeyDown fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700 }}>{message.subject}</DialogTitle>
      <DialogContent>
        {message.teamName ? (
          <Typography
            variant="caption"
            sx={{ display: "block", color: "text.secondary" }}
          >
            {message.teamName}
          </Typography>
        ) : null}
        <Typography
          variant="caption"
          sx={{ display: "block", color: "text.secondary", mb: 1 }}
        >
          {format(new Date(message.created), "yyyy-MM-dd HH:mm")}
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
          {message.content}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => acknowledgeImmediate(message.id)}
          variant="contained"
        >
          {t("teamMessages.immediate.acknowledge")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
